import {
  formatCurrency,
  formatDate,
  formatPercent,
  TitleCasePipe,
} from '@angular/common';

const titleCasePipe = new TitleCasePipe();

export const capitalizeText = (value: string) => titleCasePipe.transform(value);

export const hideUserEmail = (email: string): string => {
  let userEmail = email.split('@')[0];
  const userDomain = email.split('@')[1];
  userEmail =
    userEmail.slice(0, 1) +
    '*'.repeat(userEmail.length - 2) +
    userEmail.slice(-1);
  userEmail = userEmail.concat('@', userDomain);
  return userEmail;
};

export const hidePhoneNumber = (phoneNumber: string): string => {
  const sliceNumber = phoneNumber.slice(5).split('-');
  const userNumber = sliceNumber[0].replace(/\d/g, '*').concat(sliceNumber[1]);
  return userNumber;
};

export const ocultarNumeroTelefono = (phoneNumber: string): string => {
  if (!phoneNumber) {
    return '';
  }
  const extension = phoneNumber.slice().split(' ', 1)[0];

  const numeroTelefono = phoneNumber.split(' ').join('').split('-').join('');
  const numero = numeroTelefono.slice(extension.length, numeroTelefono.length);

  const cantidadExtraer = Number((numero.length / 2).toFixed(0));
  const mitadNumero = numero.slice(0, cantidadExtraer);
  const otraMitadNumero = numero.slice(cantidadExtraer, numero.length);
  const telefonoOculto = extension
    .concat(mitadNumero.replace(/./g, '*'))
    .concat(otraMitadNumero);

  return telefonoOculto;
};

export const formatToCurrency = (
  value: number,
  currency = ' ',
  currencyCode = 'HNL'
): string => formatCurrency(value, 'es-US', currency, currencyCode, '1.2-2');

export const formatToPercent = (value: number): string =>
  formatPercent(value, 'es-US', '1.2-2');
export const formatToDate = (value: Date | string, format = 'dd/MM/yyyy') =>
  formatDate(value, format, 'es');
export const formatToSingleDate = (value: string): string =>
  formatDate(value, 'dd/MM/yyyy', 'es');

export const stringToBoolean = (value: string): boolean =>
  value.toLowerCase() === 'true';
